import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';



export default function RBMGSTTable({rows,Month1,Month2,Month3}) {
  
const columns = [
  { field: "id", headerName: "ID", width: 40, hide: true },
  {
    field: 'teamcode',
    headerName: 'Team Code',
    width: 90,
    sortable: false,
    align:"center",
    hide: true
  },
  {
    field: 'abmname',
    headerName: 'ABM Name',
    width: 160,
    sortable: false,
  },
  {
    field: 'brand',
    headerName: 'Brand',
    width: 120,
    sortable: false,
  },
  {
    field: 'm1_adjusted_budget_value',
    headerName: `Adj.Bud V(${Month1})`,
    width: 150,
    sortable: true,

    align:"center",
    renderCell: (params, rowId) => {
      const value=(params.row.m1_adjusted_budget_value).toFixed(2)
      return (
        <p title={params.row.m1_adjusted_budget_value}  style={{align:"center"}}>
          {value}
        </p>
      );
    },
  },
  {
    field: 'm2_adjusted_budget_value',
    headerName: `Adj.Bud V(${Month2})`,
    width: 150,
    sortable: true,
    align:"center",
    renderCell: (params, rowId) => {
      const value=(params.row.m2_adjusted_budget_value).toFixed(2)
      return (
        <p title={params.row.m2_adjusted_budget_value}  style={{align:"center"}}>
          {value}
        </p>
      );
    },
  },
  {
    field: 'm3_adjusted_budget_value',
    headerName: `Adj.Bud V(${Month3})`,
    width: 150,
    sortable: true,
    align:"center",
    renderCell: (params, rowId) => {
      const value=(params.row.m3_adjusted_budget_value).toFixed(2)
      return (
        <p title={params.row.m3_adjusted_budget_value}  style={{align:"center"}}>
          {value}
        </p>
      );
    },
  },
  {
    field:'lq_m1_v_sales',
    headerName:`Sales V (${Month1} 2021)`,
    width: 90,
    sortable: true,

    align:"center",
    renderCell: (params, rowId) => {
      const value=(params.row.lq_m1_v_sales).toFixed(1)
      return (
        <p title={params.row.lq_m1_v_sales}  style={{align:"center"}}>
          {value}
        </p>
      );
    },
  },
  {
    field: 'lq_m2_v_sales',
    headerName: `Sales V (${Month2} 2021)`,
    width: 90,
    sortable: true,
    align:"center",
    renderCell: (params, rowId) => {
      const value=(params.row.lq_m2_v_sales).toFixed(1)
      return (
        <p title={params.row.lq_m2_v_sales} style={{align:"center"}}>
          {value}
        </p>
      );
    },
  },
  {
    field: 'lq_m3_v_sales',
    headerName:`Sales V (${Month3} 2021)`,
    width: 90,
    sortable: true,
    align:"center",
    renderCell: (params, rowId) => {
      const value=(params.row.lq_m3_v_sales).toFixed(1)
      return (
        <p title={params.row.lq_m3_v_sales}  style={{align:"center"}}>
          {value}
        </p>
      );
    },
  },
  {
    field: 'm1_growthsummary',
    headerName:   `% Gr (${Month1})`,
    width: 150,
    sortable: true,
    align:"center",
    renderCell: (params, rowId) => {
      const value=((params.row.m1_growthsummary)).toFixed(1)

      return (
        <p title={params.row.m1_growthsummary}  style={{align:"center"}}>
          {value}
        </p>
      );
    },
  },
  {
    field: 'm2_growthsummary',
    headerName: `% Gr (${Month2})`,
    width: 150,
    sortable: true,
    align:"center",
    renderCell: (params, rowId) => {
      const value=((params.row.m2_growthsummary)).toFixed(1)

      return (
        <p title={params.row.m2_growthsummary}  style={{align:"center"}}>
          {value}
        </p>
      );
    },
  },
  {
    field: 'm3_growthsummary',
    headerName:  `% Gr (${Month3})`,
    width: 150,
    sortable: true,
    align:"center",
    renderCell: (params, rowId) => {
      const value=((params.row.m3_growthsummary)).toFixed(1)
      return (
        <p title={params.row.m3_growthsummary} style={{align:"center"}}>
          {value}
        </p>
      );
    },
  },
   {
    field: 'total_adjusted_budget_value',
    headerName:  `Total Adj.Bud V`,
    width: 150,
    sortable: true,
    align:"center",
    renderCell: (params, rowId) => {
      const value=((params.row.total_adjusted_budget_value)).toFixed(1)
      return (
        <p title={params.row.total_adjusted_budget_value} style={{align:"center"}}>
          {value}
        </p>
      );
    },
  },
  {
    field: 'total_sales',
    headerName:  `Total Sales`,
    width: 150,
    sortable: true,
    align:"center",
    renderCell: (params, rowId) => {
      const value=((params.row.total_sales)).toFixed(1)
      return (
        <p title={params.row.total_sales} style={{align:"center"}}>
          {value}
        </p>
      );
    },
  },
  {
    field: 'total_growthsummary',
    headerName:  `Total % Gr`,
    width: 150,
    sortable: true,
    align:"center",
    renderCell: (params, rowId) => {
      const value=((params.row.total_growthsummary)).toFixed(1)
      return (
        <p title={params.row.total_growthsummary} style={{align:"center"}}>
          {value}
        </p>
      );
    },
  },
];
  return (
    <div style={{ height: 480, width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={15}
        rowsPerPageOptions={[15]}
        density='compact'
      />
    </div>
  );
}
